module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "boutique"
  }, [_c('div', {
    staticClass: "boutique-top",
    style: ({
      background: ("url(" + _vm.topImgBg + ") top center")
    })
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('ul', {
    staticClass: "superGoods-list"
  }, _vm._l((_vm.superGoods), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "title": item.aname,
        "width": "323",
        "height": "209"
      }
    })])], 1)
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "b-title"
  }, [_c('img', {
    attrs: {
      "src": _vm.btitle02
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('ul', {
    staticClass: "goods-list"
  }, _vm._l((_vm.goodGoods), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": item.url,
        "title": item.name,
        "width": "190",
        "height": "190"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "goods-name"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "goods-price"
    }, [_vm._v("活动价:"), _c('em', {
      staticClass: "sale-price"
    }, [_vm._v("¥" + _vm._s(item.price))])]), _vm._v(" "), _c('div', {
      staticClass: "add-cart"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/goods',
          query: {
            goods_id: item.goodsId
          }
        },
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "icon-cart m-r5",
      style: ({
        background: ("url(" + _vm.iconCart + ")")
      })
    }), _c('span', [_vm._v("立即购买")])])], 1)], 1)
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7abac38d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/goods-boutique/index.vue
// module id = 1643
// module chunks = 1